const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const ScratchTicketAdd = () => import(/* webpackChunkName: "scratch" */ './ticket/view/add.vue');
const ScratchTicketEdit = () => import(/* webpackChunkName: "scratch" */ './ticket/view/edit.vue');
const ScratchTicketList = () => import(/* webpackChunkName: "scratch" */ './ticket/view/index.vue');

export const ROUTE_NAME_SCRATCH = {
    TICKET: {
        INDEX: 'ScratchTicketList',
        ADD: 'ScratchTicketAdd',
        EDIT: 'ScratchTicketEdit'
    }
} as const;

export default [
    {
        path: '/app/:appId/scratch/ticket',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_SCRATCH.TICKET.INDEX,
                component: ScratchTicketList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_SCRATCH.TICKET.ADD,
                component: ScratchTicketAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id',
                name: ROUTE_NAME_SCRATCH.TICKET.EDIT,
                component: ScratchTicketEdit,
                meta: { requiresAuth: true }
            }
        ]
    }
];
